import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@services/auth/auth.service';
import { AccountServiceResponse } from '@core/generated/openapi';

export const AgingSubscribedGuard: CanActivateFn = (route, state) => {
    if (
        inject(AuthService).isModuleSubscribedTo(
            AccountServiceResponse.ServiceTypeEnum.AgingClaims,
        )
    ) {
        return true;
    }

    inject(Router).navigate(['aging/notSubscribed']);
    return false;
};
